import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import PropTypes from "prop-types";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function ASNStatusPieChart({ approved = 0, pending = 0 }) {
  const data = {
    labels: ["Approved ASN", "Pending ASN"],
    datasets: [
      {
        data: [approved, pending],
        backgroundColor: ["#43A047", "#FFA726"], // Green & Yellow
        borderColor: ["#43A047", "#FFA726"],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.label}: ${context.raw ?? 0}`,
        },
      },
    },
  };

  return (
    <div
      style={{
        height: "100%", // 👈 SET PIE CHART HEIGHT HERE
        width: "100%",
      }}
    >
      <Pie data={data} options={options} />
    </div>
  );
}

// ✅ Add this at the bottom
ASNStatusPieChart.propTypes = {
  approved: PropTypes.number,
  pending: PropTypes.number,
};
